import packageJson from '../package.json';

export const FE_VERSION = packageJson.version;
